import { ScatterplotLayer } from 'deck.gl';
import { PARAMETROS_MARCADOR, pesoCatchment } from './pulso';

// Colores por tipo de servicio. El verde de supermercados es un teal (con
// componente azul) y no un verde puro: junto al rosado de farmacias, un par
// rojo-verde seria indistinguible para deuteranopia/protanopia.
export const COLORES_TIPO = {
  farmacias: [255, 93, 115],
  supermercados: [64, 224, 200],
  bancos: [199, 146, 234],
  salud: [79, 147, 255],
};

const COLOR_APAGADO = [42, 42, 51];
const OPACIDAD_APAGADA = 38; // ~0.15 de 255
const RADIO_MIN = 3.2; // servicio alcanzado a 20-30 min (aporta poco al indice)
const RADIO_MAX = 7; // servicio alcanzado a menos de 10 min
const RADIO_APAGADO = 2;

// El tamano y la opacidad del punto encendido siguen el peso de catchment del
// E2SFCA (raiz para que el tramo intermedio no se apague de mas): un servicio
// cercano aporta mas al indice y se ve mas grande y brillante que uno lejano.
function realce(minutos) {
  return Math.sqrt(pesoCatchment(minutos));
}

// Capa base con todos los servicios apagados. No depende del reloj de la
// animacion: deck.gl no la reevalua durante el escaneo. "onClick" reenvia el
// click a la celda del servicio: sin esto, clickear sobre un punto (que tapa
// a la grilla en el picking) no lanzaria ningun escaneo.
export function construyeCapaDestinosBase({ amenities, onClick }) {
  return new ScatterplotLayer({
    id: 'destinos-base',
    data: amenities,
    pickable: true,
    onClick,
    radiusUnits: 'pixels',
    stroked: false,
    parameters: PARAMETROS_MARCADOR,
    getPosition: (d) => [d.lon, d.lat],
    getRadius: RADIO_APAGADO,
    getFillColor: [...COLOR_APAGADO, OPACIDAD_APAGADA],
  });
}

// Capa de servicios ya alcanzados por el frente. "alcanzados" (App.js) trae
// solo los encendidos con sus minutos, asi que los accessors no consultan el
// reloj: el brillo de cada servicio queda fijo desde que se enciende.
export function construyeCapaDestinos({ alcanzados, onClick }) {
  if (!alcanzados || alcanzados.length === 0) return null;

  return new ScatterplotLayer({
    id: 'destinos',
    data: alcanzados,
    pickable: true,
    onClick,
    radiusUnits: 'pixels',
    stroked: false,
    parameters: PARAMETROS_MARCADOR,
    getPosition: (d) => [d.lon, d.lat],
    getRadius: (d) => RADIO_MIN + realce(d.minutos) * (RADIO_MAX - RADIO_MIN),
    getFillColor: (d) => {
      const opacidad = Math.round(115 + realce(d.minutos) * 140);
      return [...(COLORES_TIPO[d.tipo] ?? COLOR_APAGADO), opacidad];
    },
  });
}
